import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import { CurrentUserModel, OtherUserListModel } from "../Home/Home.model";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";
import {
  FileShareFullListInterface,
  FileShareFullListModel,
  FileShareFullListResult,
} from "../FileShare/components/SelectUserComponent/SelectUserComponent.model";

const getTeammatesListData = async (params: any,selectedNetwork?:any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `team/teammate/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork ?? ""}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&categorise=true&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&time_zone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userListResp = res as any;
      const result: any = {
        isSuccess: userListResp.isSuccess,
        result: setUserListRespModel(userListResp.result?.[0]),
        status: userListResp.status,
        message: userListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const setTeamListModel = (payload: any): any => {
  let DoctorListArray = payload.map((object: any, key: any) => {
    return {
      createdBy: object.created_by,
      favorite: object.favorite,
      endTime: object.end_time,
      givenName: object.given_name,
      login_user_joined_team: object.login_user_joined_team,
      isDeleted: object.is_deleted,
      isRemote: object.is_remote,
      site: object.site,
      startTime: object.start_time,
      teamExpiryDate: object.team_expiry_date,
      teamExpiryTime: object.team_expiry_time,
      teamGuid: object.team_guid,
      teamId: object.team_id,
      team_name: object.team_name,
      teamStartDate: object.team_start_date,
      teamStartTime: object.team_start_time,
      teammates: object.teammates,
    };
  });
  return DoctorListArray;
};

const mapFileShareFullListResult = (
  payload: Array<FileShareFullListResult>
) => {
  let resultListArray = payload.map((object: FileShareFullListResult) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: setTeamListModel(object.data),
    };
  });
  return resultListArray;
};

const getfilteredTeammatesList = async (
  params: any,
  searchInput: string,
  pageNo: number
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `team/teammate/?reg_code=${utilService.getNetwork()}&hour=${utilService
        .getCurrentHour()
        .toString()}&minute=${utilService
        .getCurrentMinutes()
        .toString()}&date=${utilService.getCurrentDate()}&categorise=false&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }&search_name=${searchInput}&page=${pageNo}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )

    .then((res) => {
      const userListResp = res as any;
      var resultData: any;
      if (userListResp.result) {
        resultData = mapFileShareFullListResult(userListResp.result);
      }
      const result: FileShareFullListInterface = {
        isSuccess: userListResp.isSuccess,
        status: userListResp.status,
        message: userListResp.message,
        result: resultData,
        filteredResult: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getFavouriteTeamsList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `team/favorite-teams/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )

    .then((res) => {
      const userListResp = res as any;
      const result: FileShareFullListInterface = {
        isSuccess: true,
        status: userListResp.status,
        message: userListResp.message,
        result: userListResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const setUserListRespModel = (payload: any): any => {
  const homeResult = {
    currentUser: setCurrentUser(payload.current_user),
    otherUserList: setOtherUserList(payload.other_user_list),
  };

  return homeResult;
};

const setCurrentUser = (payLoad: any) => {
  const currentUser: CurrentUserModel = {
    available: payLoad.available,
    firstName: payLoad.first_name,
    lastName: payLoad.last_name,
    nextShift: payLoad.next_shift,
    nextShiftHours: payLoad.next_shift_hours,
    profilePic: payLoad.profile_pic,
  };
  return currentUser;
};

const setOtherUserList = (payLoad: any) => {
  const otherUserList: OtherUserListModel = {
    added: setAddedList(payLoad.added),
    own: setOwnList(payLoad.own),
  };
  return otherUserList;
};

const setAddedList = (payLoad: any) => {
  const addedObjects: any = {};
  Object.entries(payLoad).forEach(([key, value]) => {
    let valueItem: any = value;
    addedObjects[key] = {
      data: doctorsListService.setDoctorListModel(valueItem.data),
      scheduleId: valueItem.team_id,
      ownTeam: valueItem.own_team,
      teamAdmin: valueItem.team_admin,
      teamSiteId: valueItem.site_id,
      teamExpiryDate: valueItem.team_expiry_date,
      teamExpiryTime: valueItem.team_expiry_time,
      teamStartDate: valueItem.team_start_date,
      teamStartTime: valueItem.team_start_time,
      teamName: valueItem.team_name,
    };
  });
  return addedObjects;
};

const setOwnList = (payLoad: any) => {
  return payLoad;
};

const handleErrorResponse = () => {};

export const teamsListService = {
  getTeammatesListData,
  handleErrorResponse,
  getfilteredTeammatesList,
  getFavouriteTeamsList,
};
